import React, {useState,useEffect} from 'react'
import {
    useParams,
    Navigate,
    Link
} from 'react-router-dom';
import axios from "axios"
import Loader from '../../../components/Loader';
import axiosInstance from '../../../utils/api';

type Props = {}
interface SimcardInterface {
    id?: number;
    serial: string;
    date_register?: string;
    node?: string;
    active?: number;
}

const SimcardAddEdit = (props: Props) => {
    const {type, id} = useParams()
    const [loading, setLoading] = useState(false)
    const [inputs, setInputs] = useState([
        {
            serial: ""
        }
    ])
    const [input, setInput] = useState<SimcardInterface>(
        {
            serial: "",
            date_register: "",
            active: 1
        }
    )

    useEffect(() => {
        if (type=="edit" && id) {
            getData(id)
        }
    }, [])


    if (type!="add"&&type!="edit") {
        console.log(1, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="add"&& id) {
        console.log(2, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="edit"&& !id) {
        console.log(3, type)
        return <Navigate to="/" replace={true} />
    }

    
    function getData(id:string):void {
        setLoading(true)
        axiosInstance.get(`https://api.cl-ds.com/internal/operations/v1/simcard/${id}`).then(res => {
            setLoading(false)
            console.log(12, res)
            setInput(res.data)
        }).catch(err => {
            setLoading(false)
            console.log(234, err)
            return <Navigate to="/" replace={true} />
        })
    }
    

    function handleSubmit() {
        if (type=="add") {
            console.log("handleSubmit", inputs)
            setLoading(true)
            axiosInstance.post("https://api.cl-ds.com/internal/operations/v1/simcard/", inputs).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        } else {
            console.log("handleSubmit", input)
            setLoading(true)
            axiosInstance.put(`https://api.cl-ds.com/internal/operations/v1/simcard/${id}/`, input).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        }
    }

    function handleChange(e:React.ChangeEvent<HTMLInputElement>, index:number ) {
        console.log("handleChange", inputs)
        let newArr = [...inputs]
        newArr[index] = {
            serial: e.target.value
        }

        setInputs(newArr)
    }

    
    function handleChangeInput(e:React.ChangeEvent<HTMLInputElement>) {
        console.log("handleChangeInput", input)
        setInput(prev => ({
            ...prev,
            "date_register": e.target.value
        }))
    }

    function addInput() {
        setInputs(prev => [...prev , { serial: ""}])
    }

    
    function removeInput(index:number) {
        setInputs(prev => [...prev , { serial: ""}])
        let newArr = inputs.filter( (input, i) => i != index)

        setInputs(newArr)
    }

    function handleChangeSelect(e:React.ChangeEvent<HTMLSelectElement>) {
        setInput(prev => ({
            ...prev,
            "active": parseInt(e.target.value)
        }))
    }

    return (
        <div className="col-12">
        {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                <div style={{float: "right", margin: "1rem", marginLeft: 0, marginBottom: 0}}>
                    <Link  to={`/simcard`} className="nav-link collapsed">
                        <button type="button" className="btn btn-outline-secondary">Back</button>
                    </Link>
                </div>
                <h5 className="card-title">{type=="add" ? "Create" : "Edit"} Simcard</h5>

                    {type == "add" && 
                        inputs.map( (input, index) => {
                            return (
                                <div className="row mb-3" key={index}>
                                    <label className="col-sm-2 col-form-label">Serial #{index}</label>
                                    <div className="col-sm-8">
                                        <input type="text" className="form-control" id="inputText" value={input.serial} onChange={(e)=>handleChange(e, index)}/>
                                    </div>
                                    <div className="col-sm-1" onClick={()=>{addInput()}}>
                                        <button type="button" className="btn btn-outline-info"><i className="bi bi-plus"></i></button>
                                    </div>
                                    {index!=0 && (
                                    <div className="col-sm-1" onClick={()=>{removeInput(index)}}>
                                        <button type="button" className="btn btn-outline-danger"><i className="bi bi-dash"></i></button>
                                    </div>
                                    )}
                                </div>
                            )
                        })
                    }

                    {type == "edit" && 
                        <>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Serial</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.serial} disabled />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Date Register</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.date_register} onChange={(e)=>handleChangeInput(e)}/>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Active</label>
                            <div className="col-sm-10">
                                <select className="form-select" aria-label="select" value={input.active || "0"} onChange={(e)=>handleChangeSelect(e)}>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                        </div>
                        </>
                    }
                    
                    
                    <div className="text-start">
                        <button type="button" className="btn btn-outline-info" onClick={()=>handleSubmit()}>Submit</button>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default SimcardAddEdit